import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { FaCheck, FaEraser } from 'react-icons/fa';

import Const from '../../util/Constants';
import ColdTextFilter from "./ColdTextFilter";
import ColdDateFilter from "./ColdDateFilter";

import '../filter/Filter.css';
import { ColdSelectFilter } from './ColdSelectFilter';

const coldDataCallFields = [
  { field_key: "date_time", field_type: "datetime", label_name: "Date Time" },
  { field_key: "name", field_type: "text", label_name: "Name" },
  { field_key: "phone_number", field_type: "text", label_name: "Phone" },
  { field_key: "email", field_type: "text", label_name: "Email" },
  { field_key: "address", field_type: "text", label_name: "Address" },
  { field_key: "remark", field_type: "text", label_name: "Remark" },
  // { field_key: 'lead_generated',field_type: 'number',   label_name: 'Lead'       },
  { field_key: "feedback", field_type: "select", label_name: "Feedback" },
  { field_key: "duration", field_type: "number", label_name: "Duration" },
];

class ColdDataCallFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = { changed: false, search: '' };
    this.filters = [...(props.filters || [])];
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.filters = [...(props.filters || [])];
    this.setState({ changed: !this.state.changed });
  }

  onValueChange = (field, condition, value) => {
    let filter = this.filters.find(f => f.field === field);
    if (!filter) {
      filter = { field };
      this.filters.push(filter);
    }
    filter.condition = condition;
    filter.value     = value;
  };

  resetFilter = field => {
    this.filters = this.filters.filter(f => f.field !== field);
    this.setState({ changed: !this.state.changed });
  };

  clearFilters = () => {
    this.filters = [];
    this.setState({ search: '', changed: !this.state.changed });
    this.props.onFilterChange(this.filters);
  };

  applyFilters = () => {
    this.setState({ search: '' });
    this.props.onFilterChange(this.filters);
  };

  onSearch = e => {
    this.setState({ search: e.target.value });
  };

  loadFilterRow = (field, i) => {
    const filter = this.filters.find(f => f.field === field.field_key);
    const type   = field.field_type;

    if (type === 'datetime' || type === Const.Date || type === Const.DateTime) {
      return (
        <ColdDateFilter
          key={`cdf_date_${i}`}
          filter={filter}
          field={field}
          onValueChange={this.onValueChange}
          resetFilter={this.resetFilter}
        />
      );
    } else if(type === "select") {
      return <ColdSelectFilter 
        key={`cdf_sel_${i}`}
        filter={filter}
        field={field}
        onValueChange={this.onValueChange}
        resetFilter={this.resetFilter}
        options={this.props.feedbackOptions}
      />
    }
    // text / number / email / phone / address / remark all use the text row
    return (
      <ColdTextFilter
        key={`cdf_text_${i}`}
        filter={filter}
        field={field}
        onValueChange={this.onValueChange}
        resetFilter={this.resetFilter}
      />
    );
  };

  render() {
    if (!this.props.isFilterOpen) return null;

    const { search } = this.state;
    const uiFilters = coldDataCallFields
      .filter(f => f.label_name.toLowerCase().includes(search.toLowerCase()))
      .map((f, i) => this.loadFilterRow(f, i));

    return (
      <div className="col-md-3 point5 filtersec">
        <div className="m-20p">
          <div className="stickytop">
            <div className="col-md-12 d-flexx">

              {/* Search box */}
              <span className="wi-35">
                <FormControl
                  type="text"
                  value={search}
                  onChange={this.onSearch}
                  placeholder="Column Name"
                />
              </span>

              {/* Apply */}
              <span className="wi-20" onClick={this.applyFilters}>
                <span className="btn btn-lead btn-sm">
                  <FaCheck /> Apply
                </span>
              </span>

              {/* Clear */}
              <span className="wi-20" onClick={this.clearFilters}>
                <span className="btn btn-lead btn-sm">
                  <FaEraser /> Clear
                </span>
              </span>

              {/* Close */}
              <span className="wi-20" onClick={this.props.closeFilter}>
                <span className="btn btn-lead btn-sm">&times; Close</span>
              </span>

            </div>
          </div>
        </div>

        <hr />

        <div className="filtersecd p-4">
          {uiFilters}
        </div>
      </div>
    );
  }
}

export default ColdDataCallFilter;